<div class="modal-body width-500">
  <div class="layout-auto-1-auto">
		<span class="modal-header">
			Multiple Choice
		</span>
    <div class="content height-700">
      <div class="layout-auto-1">
        <!-- Search Header -->
        <exg-search-bar #searchBar [placeholder]="'Suche'"
                        (Search)="search($event)"
                        (keydown.arrowdown)="onArrowDown($event, -1)"
                        class="span-layout">
        </exg-search-bar>

        <div class="content">
          <ng-container *ngFor="let enm of getEnmObjectList(); let i = index;">
            <exg-switch #listRow
              tabindex="0"
              (keydown.arrowup)="onArrowUp($event, i)"
              (keydown.arrowdown)="onArrowDown($event, i)"
              (keydown.enter)="toggleSwitchValue(enm)"
              name="{{enm.enmText}}"
              style="align-self: start; overflow: visible"
              [caption]="enm.enmText"
              [(ngModel)]="enm.enmValue"
              [tooltip]="enm.uiTooltip">
            </exg-switch>
          </ng-container>
        </div>
        <!--<div class="content">
          <ng-container *ngFor="let enm of getEnmObjectList(); let i = index;">
            <exg-switch name="{{enm.enmText}}" style="align-self: start; overflow: visible"
                        [caption]="enm.enmText"
                        [(ngModel)]="enm.enmValue"
                        [tooltip]="enm.uiTooltip"></exg-switch>
          </ng-container>
        </div>-->
      </div>
    </div>
    <div class="spawn-modal-actions grid-1-auto">
      <div class="typo-small">
        ({{countTrue}} ausgewählt)
      </div>
      <div class="typo-small">
        <button (click)="cancel()" class="md-btn">
          {{getGlobal('Cancel')}}
        </button>
        <button (click)="save()" class="md-btn">
          {{getGlobal('Save')}}
        </button>
      </div>
    </div>
  </div>
</div>
